<template>
 <div class='promotionCenterCont'>
     <div class="searchCont">      
        <div class="promotionSearchBox" ref="searchBtnRef">
            <input type="text" :class="{focusInput: isFocusIpt}" @focus="focusHanle()" v-model="searchKey" @:blur="changeInpt()"  placeholder="请输入商品名称"/>
            <span class="searchIcon"></span>
            <span class="escSearch" @click="escSearchIpt()" v-show="isFocusIpt"></span>
            <span class="searchBtn"  v-show="isFocusIpt && !isShowEsc" @click="searchHandle()">搜索</span>
            <span class="searchBtn"  v-show="isShowEsc" @click="escSearchIpt()">取消</span>
        </div>

     </div>

     <div class="promotionListCont">

         <div v-if="listData.length">

            <div class="promotionList"   v-for="(item,index) in listData" :key="index" @click="jumpGoodsDetailHandle(item)">
                <div class="promotionListTop">
                    <div class="promotionPoster">
                        <img :src="item.picUrl"/>
                    </div>
                    <div class="promotionIntroduce">
                        <p class="title">{{item.goodsName}}</p>
                        <p class="promotionOrigin"><span class="field">来源：</span><span>{{item.branchName}}</span></p>
                        <p class="promotionSalePrice"><span class="field">价格：</span><span v-if="item.salePrice != '免费'">¥{{item.salePrice}}</span><span v-else>{{item.salePrice}}</span></p>
                    </div>
                </div>

                <div class="promotionListBottom">
                    <div class="promotionPrice">
                        预计收益<span><font v-if="item.salePrice != '免费'">¥</font>{{item.reward}}</span>
                    </div>

                    <div class="seeQrcode" @click.stop="seeQrcocdeHandle(item)">查看二维码</div>
                </div>              
            </div>
        </div>

        <div class="noTuiguangList" v-else>暂无数据</div>
     </div>

    <Footer></Footer>
     
 </div>
</template>

<script>
import Vue from 'vue'
import $ from "jquery";
import { Toast } from 'vant';
import Footer  from './footer';

export default {
    name: "promotionCenter",

    data () {
        return {
            searchKey: '',
            isFocusIpt: false,
            isShowEsc: false,
            paging: {
                params: {
                    pageNum: 1,
                    pageSize: 10
                },
                
                total: 0,
                totalPages: 0,
            },

            currentNavText: 'center',
            listData: [],
            loadMoreStatus: "more",
            total: 0,
        };
    },
    components: {
        Footer
        
    },

    computed: {

    },


    created(){        


       
    },

    mounted(){

       localStorage.setItem("currentPromationNav",'center')
            console.log('localStorage.setItem("currentPromationNav")====', localStorage.getItem("currentPromationNav"))
            this.getData()
            $(window).scroll(() => {
                //判断是否滑动到页面底部
                if (
                    Math.round($(window).scrollTop()) ===
                    $(document).height() - $(window).height()
                ) {
                    // TODO 滑动到底部时可请求下一页的数据并加载，加载可使用append方法
                    this.reachBottom();
                }
            });
       
    },
    destroyed(){
        
    },

    methods: {
        focusHanle() {
            this.isFocusIpt = true
        },

        escSearchIpt() {
            this.isFocusIpt = false;
            this.isShowEsc = false;
            this.searchKey = ''
            this.paging.params.pageNum = 1
            this.getData()
        },


        searchHandle() {
            this.getData()
            this.isShowEsc = true
        },

        changeInpt() {
            if (!this.searchKey) {
                this.getData()
            }
        },

        seeQrcocdeHandle(item) {
            this.$router.push({
                path: '/seeTuiguangQrcode',
                query: {
                    goodsId: item.goodsId,
                    agentId: item.agentId,
                }
            })           
        },
        jumpGoodsDetailHandle(item) {
            this.$router.push({
                path: '/goodsDetail',
                query: {
                    goodsId: item.goodsId,
                    agentId: item.agentId,
                    backName:this.$route.path,
                    form: 'promotionCenter'
                }
            })          
        },

        getData(type){
            this.$api.agentManage.findByCondition(
                {
                    pageNum: this.paging.params.pageNum,
                    pageSize:  this.paging.params.pageSize,
                    goodsName: this.searchKey, 
                }
            )
            .then(res=>{
                    if (res.data) {
                        if (type === "reachBottom") {
                            this.listData = this.listData.concat(res.data.list);
                        } else {
                            this.listData = res.data.list || [];
                        }
                        this.total = res.data.total;
                        if (this.total <= this.paging.params.pageNum * this.paging.params.pageSize) {
                            this.loadMoreStatus =
                                type === "reachBottom" ? "noMore" : "none";
                        } else {
                            this.loadMoreStatus = "more";
                        }
                    }

            })
        },

        reachBottom() {
            if (this.total > this.paging.params.pageNum * this.paging.params.pageSize) {
                this.paging.params.pageNum = this.paging.params.pageNum + 1;
                this.loadMoreStatus = "loading";
                this.getData("reachBottom");
            } else {
                this.loadMoreStatus = "noMore";
            }
        },     
    },

}

</script>


<style  scoped>
 @import "../asset/css/agentManage.css";
</style>
